import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import { LOCAL_COLORS, LOCAL_CONTENT_MAX_WIDTH } from 'styles/constants';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';
import getContrastingColor from 'utils/getContrastingColor';

export const StepsContainer = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: ${SPACER.large} ${SPACER.medium} ${SPACER.x3large};

  &,
  h2,
  p,
  div > div,
  div > div > span {
    color: ${({ backgroundColor }) =>
      getContrastingColor(backgroundColor)
        ? getContrastingColor(backgroundColor)
        : LOCAL_COLORS.surfaceDarkBold};
  }

  li {
    border-color: ${({ backgroundColor }) =>
      getContrastingColor(backgroundColor)};
  }

  circle {
    stroke: ${({ backgroundColor }) => getContrastingColor(backgroundColor)};
  }

  path {
    fill: ${({ backgroundColor }) => getContrastingColor(backgroundColor)};
  }

  ${MEDIA_QUERIES.mdUp} {
    padding: ${SPACER.large} ${SPACER.xlarge} 80px;
  }

  ${MEDIA_QUERIES.xlUp} {
    padding: ${SPACER.large} 72px 100px;
  }

  ${MEDIA_QUERIES.xxlUp} {
    padding: ${SPACER.large} 0 120px;
  }
`;

export const InnerBox = styled.div`
  ${MEDIA_QUERIES.mdUp} {
    max-width: ${LOCAL_CONTENT_MAX_WIDTH};
    margin: auto;
  }
`;

export const InnerBoxBelowHero = styled(InnerBox)`
  ${MEDIA_QUERIES.xlUp} {
    padding: 0 72px 100px;
  }

  ${MEDIA_QUERIES.xxlUp} {
    padding: 0 0 120px;
  }
`;

export const Header = styled.h2`
  font-size: 32px;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -0.64px;
  margin-bottom: ${SPACER.medium};

  ${MEDIA_QUERIES.mdUp} {
    max-width: 400px;
  }

  ${MEDIA_QUERIES.xlUp} {
    font-size: 52px;
    max-width: 900px;
  }
`;

export const BodyContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: ${SPACER.large};

  ${MEDIA_QUERIES.mdUp} {
    margin-bottom: ${SPACER.x5large};
  }
`;

export const Subheader = styled.div`
  font-size: 16px;
  line-height: 132%;

  ${MEDIA_QUERIES.mdUp} {
    font-size: 16px;
    line-height: 132%;
    max-width: 400px;
  }

  ${MEDIA_QUERIES.xlUp} {
    font-size: 24px;
    line-height: 140%;
    max-width: 900px;
  }
`;

export const StepsListContainer = styled.ol`
  margin: 0 0 ${SPACER.x5large};

  ${MEDIA_QUERIES.mdUp} {
    display: flex;
    max-width: 100%;
    gap: ${SPACER.medium};
    margin-bottom: 120px;
  }

  ${MEDIA_QUERIES.lgUp} {
    margin-bottom: ${SPACER.x5large};
  }

  ${MEDIA_QUERIES.xlUp} {
    gap: ${SPACER.large};
    margin-bottom: 120px;
  }

  ${MEDIA_QUERIES.xxlUp} {
    margin-bottom: ${SPACER.x5large};
  }
`;

export const Disclaimer = styled.div`
  font-size: 14px;
  line-height: 140%;
`;

export const desktopCtaStyles = css`
  ${desktopOnly()}
  font-size: 16px;
  font-weight: 700;
  line-height: 132%;
  letter-spacing: -0.32px;
  max-width: 258px;
  margin-left: auto;

  small {
    margin-top: ${SPACER.small};
    font-weight: 400;
  }
`;

export const mobileCtaStyles = css`
  ${mobileOnly()}
  margin-bottom: ${SPACER.x5large};

  small {
    margin-top: ${SPACER.small};
    font-weight: 400;
  }
`;
